import { useQueryClient } from '@tanstack/react-query'
import { useAuthMutation } from './auth'
import { ApiAgentRequest, request } from '../utils/request'
// import { UpdatePassportByIdRequest } from '@backend/students-api/routes/documents/passports/{id}/PATCH/types'
import { PassportResource } from '@backend/agents-ui-api/resources/student-document/passport/types'

type UpdatePassportProps = {
  id?: string
}

export type UpdatePassportParams = {
  passportNumber?: string
  expiryDate?: string
  nationality?: string
}

export type RawPassportResponse = {
  data: PassportResource
}


export function useUpdatePassport(props: UpdatePassportProps) {
  const queryClient = useQueryClient()

  const { isPending, mutate } = useAuthMutation(
    async (params: UpdatePassportParams) => {
      return await request<RawPassportResponse>(
        new ApiAgentRequest(`/students/documents/passports/${props.id}`, {
          method: 'PATCH',
          body: {
            data: {
              type: 'passport',
              attributes: {
                passportNumber: params?.passportNumber ?? null,
                expiryDate: params?.expiryDate ?? null,
                nationality: params?.nationality ?? null,
              },
            },
          },
        }),
        {
          isExpectedResponse: (res): res is RawPassportResponse => res as boolean,
        },
      )
    },
    {
      onSuccess: data => {
        queryClient.setQueryData(['passport'], data)
      },
    },
  )

  return {
    isUpdatingPassport: isPending,
    updatePassport: mutate,
  }
}